import React from 'react';
import { PRICE, REGULAR_PRICE, SAVINGS, TOTAL_VALUE, valueStack } from '../data/valueStack';
import { Countdown } from './Countdown';
import { CtaButton } from './CtaButton';
import { Eyebrow } from './Eyebrow';
export function FinalCall() {
  return <section aria-labelledby="final-heading" className="border-y border-night-600 bg-night-950 py-14 sm:py-24" data-id="element-105" data-mp="2ylggxp8uauxn">
      <div className="mx-auto grid max-w-shell gap-10 px-5 sm:px-6 lg:grid-cols-2 lg:items-center lg:gap-20" data-id="element-106" data-mp="3rbyi2kq06m8f">
        <div data-id="element-107" data-mp="3mclx65iozp8h">
          <Eyebrow data-id="element-108" data-mp="3mcu65mbp2aee">Final countdown</Eyebrow>
          <h2 id="final-heading" className="mt-4 font-display text-4xl leading-[0.98] text-cream sm:text-6xl" data-id="element-109" data-mp="3mb0zi712zq6e">
            Complete package, <span className="text-amber" data-id="element-110" data-mp="3dbnpnd91ozl5">launch price</span>
          </h2>
          <div className="mt-7" data-id="element-111" data-mp="25zdk9gzdoozw">
            <Countdown initialSeconds={86347} size="lg" data-id="element-112" data-mp="260f7ejto51xz" />
          </div>
          <p className="mt-6 max-w-sm text-sm text-cream-muted" data-id="element-113" data-mp="21x0p1mi9c9hd">
            When the timer hits zero the price returns to {REGULAR_PRICE}.
          </p>
        </div>

        <div className="rounded-2xl border border-amber/50 bg-night-800 p-6 sm:p-10" data-id="element-114" data-mp="n3lac7nuuih8">
          <p className="text-xs font-semibold uppercase tracking-label text-amber sm:text-sm" data-id="element-115" data-mp="n18wo6p4qu9z">
            6 Volumes + 6 Bonuses
          </p>

          <dl className="mt-5 border-y border-night-600 py-4" data-id="element-116" data-mp="d4nppftjv93i">
            {valueStack.map(line => <div key={line.label} className="flex items-baseline justify-between gap-4 py-1.5" data-id="element-117" data-mp="3vidg6j5319h3">
                <dt className="text-xs text-cream-muted" data-id="element-118" data-mp="45sj42mlfwzo">{line.label}</dt>
                <dd className="text-xs font-semibold tabular-nums text-cream-soft" data-id="element-119" data-mp="3llig3vt5v10p">{line.value}</dd>
              </div>)}
            <div className="flex items-baseline justify-between gap-4 pt-2" data-id="element-120" data-mp="3ql3hsdzptnh4">
              <dt className="text-[10px] font-semibold uppercase tracking-label text-cream-muted" data-id="element-121" data-mp="3ckakxmlxygau">
                Total real value
              </dt>
              <dd className="text-xs font-semibold tabular-nums text-cream-muted line-through" data-id="element-122" data-mp="3hlq5zeo4cmt8">
                {TOTAL_VALUE}
              </dd>
            </div>
          </dl>

          <p className="mt-5 flex items-baseline gap-3" data-id="element-123" data-mp="1ib5garv0xuor">
            <span className="font-display text-6xl leading-none text-amber sm:text-7xl" data-id="element-124" data-mp="1dd3xm81ifxdt">{PRICE}</span>
            <span className="font-display text-xl leading-none text-cream-muted line-through" data-id="element-125" data-mp="19ck0v5kumvs7">
              {TOTAL_VALUE}
            </span>
          </p>
          <p className="mt-3 text-sm font-semibold text-amber-light" data-id="element-126" data-mp="261hu2jcyaln9">You save {SAVINGS} today</p>

          <div className="mt-7" data-id="element-127" data-mp="213zo91u8cmjh">
            <CtaButton size="lg" fullWidth data-id="element-128" data-mp="1x1co8dnenvb7">
              Yes, I want it now
            </CtaButton>
          </div>

          <ul className="mt-6 space-y-1.5 text-xs text-cream-muted" data-id="element-129" data-mp="1s3b5xuxt000s">
            <li data-id="element-130" data-mp="lmfx8y7nuw17">Payment is one-time &middot; No subscription</li>
            <li data-id="element-131" data-mp="lo0puiaf04wf">Instant access to all materials</li>
            <li data-id="element-132" data-mp="gmtl6s3kjltz">10-day satisfaction guarantee</li>
          </ul>
        </div>
      </div>
    </section>;
}